export default {
      id: "big-search-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#big-search",
      toString: function () {
        return this.url;
      }
    }